import React from 'react';
import {ErrorModal} from '@igp/shared/components/error';
import {withTraceErrorBoundary} from '@igp/shared/otel';

import {CountryLevelPartnerReportBase} from './CountryLevelPartnerReportBase';

function UserActivityOverviewInner() {
    return <CountryLevelPartnerReportBase tabId="UserActivityOverview" />;
}

export const UserActivityOverview = withTraceErrorBoundary(UserActivityOverviewInner, ErrorModal);
